// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.correctAnswerCard{
    background-color: #eafff0;
    border-color: #a2ffbb;
    margin-bottom: 16px;
}
.wrongAnswerCard{
    background-color: #ffeaea;
    border-color: #ffa2a2;
    margin-bottom: 16px;
}
/* styles.css */
.radio-red .ant-radio-inner {
    border-color: red;
  }
  
  .radio-red .ant-radio-inner::after {
    background-color: red;
  }
  
  .radio-green .ant-radio-inner {
    border-color: green !important;
    background: green;
  }
  
  .radio-green .ant-radio-inner::after {
    background-color: green !important;
  }
  
  .radio-green .ant-radio-checked .ant-radio-inner {
    border-color: green;
    background-color: green;
  }
  .radio-incorrect .ant-radio-checked .ant-radio-inner {
    border-color: red;
    background-color: red;
  }
  .reviewModuleMainDiv .radio-green:hover .ant-radio-inner {
    border-color: green;
}
  .reviewModuleMainDiv .radio-incorrect:hover .ant-radio-inner {
    border-color: red !important;
}
  .radio-correct {
    color: green;
  }
.reviewModuleMainDiv .ant-radio-wrapper{
    cursor: default;
}
.reviewModuleMainDiv .ant-space{
    width: 100%;
}
.reviewModuleMainDiv .ant-radio-group{
    width: 100%;
}
.reviewModuleMainDiv .radio-incorrect{
    width: 100%;
    background: #ff7c7c;
    padding: 10px;
    border-radius: 10px;
}
.reviewModuleMainDiv .radio-green{
    width: 100%;
    background: #5bc740;
    padding: 10px;
    border-radius: 10px;
}
.reviewModuleMainDiv .ant-radio-wrapper{
    width: 100%;
    padding: 10px;
    border-radius: 10px;
}
.correctAnswerResultType{
    float: right;
    border: 1px solid #5bc740;
    border-radius: 25px;
    padding: 5px 7px;
    width: 150px;
    text-align: center;
    color: #5bc740;
    cursor: default;
}
.wrongAnswerResultType{
    float: right;
    border: 1px solid #ff7c7c;
    border-radius: 25px;
    padding: 5px 7px;
    width: 150px;
    text-align: center;
    color: #ff7c7c;
    cursor: default;
}
.DashboardButton{
    margin-bottom: 20px;
    position: relative;
    left: 45%;
}
.reviewModuleMainDiv .ant-radio-wrapper:hover .ant-radio-inner {
    border-color: #c1c1c1;
}

.reviewModuleMainDiv{
  margin-top: 70px;
}

.Button {
    height: 56px !important;
    padding: 0 48px !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    border-radius: 16px !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    border: none !important;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4) !important;
    transition: all 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
}

.Button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5) !important;
}

.Button:active {
    transform: translateY(0);
}

.timerBox {
    height: 56px;
    padding: 0 48px;
    font-size: 18px;
    font-weight: 600;
    border-radius: 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
    transition: all 0.3s ease;  
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: white;
    margin-bottom: 20px;
}

.timerBox:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5);
}

.timerBox:active {
    transform: translateY(0);
}

.dashboardCenter {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Components/CareerProgram/CareerAssesment/MCQ/ReviewAnswerModule/ReviewAnswerModule.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;AACA,eAAe;AACf;IACI,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,mBAAmB;AACvB;EACE;IACE,4BAA4B;AAChC;EACE;IACE,YAAY;EACd;AACF;IACI,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,qBAAqB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,wEAAwE;IACxE,uBAAuB;IACvB,0DAA0D;IAC1D,oCAAoC;IACpC,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,0DAA0D;AAC9D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,6DAA6D;IAC7D,YAAY;IACZ,+CAA+C;IAC/C,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".correctAnswerCard{\n    background-color: #eafff0;\n    border-color: #a2ffbb;\n    margin-bottom: 16px;\n}\n.wrongAnswerCard{\n    background-color: #ffeaea;\n    border-color: #ffa2a2;\n    margin-bottom: 16px;\n}\n/* styles.css */\n.radio-red .ant-radio-inner {\n    border-color: red;\n  }\n  \n  .radio-red .ant-radio-inner::after {\n    background-color: red;\n  }\n  \n  .radio-green .ant-radio-inner {\n    border-color: green !important;\n    background: green;\n  }\n  \n  .radio-green .ant-radio-inner::after {\n    background-color: green !important;\n  }\n  \n  .radio-green .ant-radio-checked .ant-radio-inner {\n    border-color: green;\n    background-color: green;\n  }\n  .radio-incorrect .ant-radio-checked .ant-radio-inner {\n    border-color: red;\n    background-color: red;\n  }\n  .reviewModuleMainDiv .radio-green:hover .ant-radio-inner {\n    border-color: green;\n}\n  .reviewModuleMainDiv .radio-incorrect:hover .ant-radio-inner {\n    border-color: red !important;\n}\n  .radio-correct {\n    color: green;\n  }\n.reviewModuleMainDiv .ant-radio-wrapper{\n    cursor: default;\n}\n.reviewModuleMainDiv .ant-space{\n    width: 100%;\n}\n.reviewModuleMainDiv .ant-radio-group{\n    width: 100%;\n}\n.reviewModuleMainDiv .radio-incorrect{\n    width: 100%;\n    background: #ff7c7c;\n    padding: 10px;\n    border-radius: 10px;\n}\n.reviewModuleMainDiv .radio-green{\n    width: 100%;\n    background: #5bc740;\n    padding: 10px;\n    border-radius: 10px;\n}\n.reviewModuleMainDiv .ant-radio-wrapper{\n    width: 100%;\n    padding: 10px;\n    border-radius: 10px;\n}\n.correctAnswerResultType{\n    float: right;\n    border: 1px solid #5bc740;\n    border-radius: 25px;\n    padding: 5px 7px;\n    width: 150px;\n    text-align: center;\n    color: #5bc740;\n    cursor: default;\n}\n.wrongAnswerResultType{\n    float: right;\n    border: 1px solid #ff7c7c;\n    border-radius: 25px;\n    padding: 5px 7px;\n    width: 150px;\n    text-align: center;\n    color: #ff7c7c;\n    cursor: default;\n}\n.DashboardButton{\n    margin-bottom: 20px;\n    position: relative;\n    left: 45%;\n}\n.reviewModuleMainDiv .ant-radio-wrapper:hover .ant-radio-inner {\n    border-color: #c1c1c1;\n}\n\n.reviewModuleMainDiv{\n  margin-top: 70px;\n}\n\n.Button {\n    height: 56px !important;\n    padding: 0 48px !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    border-radius: 16px !important;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n    border: none !important;\n    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4) !important;\n    transition: all 0.3s ease !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 12px !important;\n}\n\n.Button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5) !important;\n}\n\n.Button:active {\n    transform: translateY(0);\n}\n\n.timerBox {\n    height: 56px;\n    padding: 0 48px;\n    font-size: 18px;\n    font-weight: 600;\n    border-radius: 16px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    border: none;\n    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);\n    transition: all 0.3s ease;  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    color: white;\n    margin-bottom: 20px;\n}\n\n.timerBox:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5);\n}\n\n.timerBox:active {\n    transform: translateY(0);\n}\n\n.dashboardCenter {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
